<template>
  <CRow>
    <CCol col="12" lg="12">
      <CCard>
        <CCardBody>
      <form
      @submit="saveData"
      method="post"
      >
           <h3 v-if="isEditing">
            {{ $t('button.edit') }} {{ $t('expenses.label') }}
          </h3>
          <h3 v-else>{{ $t('button.create') }} {{ $t('expenses.label') }}</h3>
          <div class="row">
            <div class="col-6">
              <CSelect
                :label="$t('expense_types.label')" 
                :value.sync="expense.expense_type_id"
                :plain="true"
                :options="expenseTypes"
                :placeholder="$t('fields.expense_type_select_placeholder')"
                required
              >
              </CSelect>
            </div>
            <div class="col-6">
              <CSelect
                :label="$t('fields.employee')" 
                :value.sync="expense.employee_id"
                :plain="true"
                :options="employees"
                :placeholder="$t('fields.employee_placeholder')"
                required
              >
             </CSelect>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <CInput prepend="$" :label="$t('fields.quantity')" type="text" placeholder="Ex: 10" v-model="expense.quantity" required></CInput>
            </div>
            <div class="col-6">
              <CInput :label="$t('fields.expense_date')" type="date" v-model="expense.expense_date" required></CInput>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <CTextarea :label="$t('fields.comment')" :placeholder="$t('fields.comment_placeholder')" v-model="expense.comment"></CTextarea>
            </div>
          </div>
            
          <CButton color="success" type="submit">
              <template v-if="isEditing"><CIcon :content="$options.updateIcon" /> {{ $t('button.update') }}</template>
              <template v-else><CIcon :content="$options.addIcon" /> {{ $t('button.create') }}</template>
              </CButton>
            <CButton color="primary" @click="goBack"><CIcon :content="$options.backIcon" /> {{ $t('button.back') }}</CButton>
          </form>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios';
import formMixin from '../../mixins/form';
import localeMixin from '../../mixins/locale'; // Order matters, mixin first then i18n.
import i18n from "../../i18n";
import { cilSync, cilPlus, cilArrowLeft } from '@coreui/icons';

export default {
  name: 'FormExpense',
  mixins: [formMixin, localeMixin],
  updateIcon: cilSync,
  addIcon: cilPlus,
  backIcon: cilArrowLeft,
  data() {
    return {
        expense: {
          name: '',
          expense_type_id: '',
          employee_id: '',
          quantity: '',
          expense_date: '',
          comment: ''
        },
        expenseTypes: [],
        employees: []
    }
  },
  mounted() {
    this.getExpenseTypes();
    this.getEmployees();
    if (this.isEditing) {
      this.getExpense();
    }
  },
  methods: {
      showAlertError() {
          if (this.message != "") {
              this.$swal({
                  title: i18n.t('modal.title'),
                  text: this.message,
                  icon: 'warning',
                  showCancelButton: true,
                  cancelButtonColor: '#d33',
              });
          } else {
              this.$swal({
                  title: i18n.t('modal.title'),
                  text: i18n.t('modal.body'),
                  icon: 'warning',
                  showCancelButton: true,
                  cancelButtonColor: '#d33',
              });
          }
      },
    goBack() {
      this.$router.push({ name: "Expenses" });
    },
    showAlert(type, msg=null) {
      let title = '';
      let body = '';
      let status = '';
      let redirect = true;

      switch(type) {
        case 'add':
          title = i18n.t('expenses.modal.created_label');
          body = i18n.t('expenses.modal.created_body');
          status = 'success';
          break;
        case 'edit':
          title = i18n.t('expenses.modal.updated_label');
          body = i18n.t('expenses.modal.updated_body');
          status = 'success';
          break;
        case 'error':
          title = 'Error';
          body = msg;
          status = 'error';
          redirect = false;
          break;
      }

      this.$swal(
        title,
        body,
        status
      ).then(result => {
        if (redirect) {
          this.goBack();
        }
      });
    },
    saveData(e) {
        e.preventDefault();
        const data = this.expense;
        this.$emit("saved", data);
        let url = `/api/expenses`;
        let sendRequest = null;

        if (this.isEditing) {
            url = url + "/" + this.$route.params.id + '?token=' + localStorage.getItem("api_token");
            sendRequest = async() => {
                try {
                    const response = await axios.put(url, data);
                    if (response.data.status === "success") {
                        this.message = 'Successfully updated expense.';
                        this.showAlert('edit');
                    }
                } catch (error) {
                    if(error.response.data.message == 'The given data was invalid.'){
                        let message = '';
                        for (let key in error.response.data.errors) {
                            if (error.response.data.errors.hasOwnProperty(key)) {
                                message += error.response.data.errors[key][0] + '  ';
                            }
                        }
                        this.showAlert('error', message);
                    } else{
                        console.log(error);
                        this.showAlertError(); 
                    }
                }
            };
        } else {
            url = url + '?token=' + localStorage.getItem("api_token");
            sendRequest = async() => {
                try {
                    const response = await axios.post(url, data);
                    if (response.data.status === "success") {
                        // this.expenseType = {
                        //   name: ''
                        // };
                        // for (const key in dataObject) {
                        //     dataObject[key] = "";
                        // }

                        this.showAlert('add');
                    }
                    // console.log(response.data);
                } catch (error) {
                    if(error.response.data.message == 'The given data was invalid.'){
                        let message = '';
                        for (let key in error.response.data.errors) {
                            if (error.response.data.errors.hasOwnProperty(key)) {
                                message += error.response.data.errors[key][0] + '  ';
                            }
                        }
                        this.showAlert('error', message);
                    } else{
                        console.log(error);
                        this.showAlertError(); 
                    }
                }
            };
        }
        sendRequest();
        return data;
    },
    getExpense() {
        const id = this.$route.params.id;
        axios.get('/api/expenses/' + id + '?token=' + localStorage.getItem("api_token"))
        .then(response => {
          const data = response.data;
          console.log(data);
          this.expense = data;
        }).catch(error => {
            console.log(error);
            this.showAlertError(); 
        });
    },
    getExpenseTypes() {
        axios.get('/api/expense-types?token=' + localStorage.getItem("api_token"))
        .then(response => {
            const data = response.data;
            data.forEach(elem => {
                this.expenseTypes.push({
                    label: elem.name,
                    value: elem.id
                });
            });
        }).catch(error => {
            console.log(error);
            this.showAlertError(); 
        });
    },
    getEmployees() {
        axios.get('/api/employees?token=' + localStorage.getItem("api_token"))
        .then(response => {
            const data = response.data;
            data.forEach(elem => {
                this.employees.push({
                    label: elem.name,
                    value: elem.id
                });
            });
        }).catch(error => {
            console.log(error);
            this.showAlertError(); 
        });
    }
  }
}

</script>
